<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Selecionar validações BDGD:</v-card-title>

      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            hide-details
            label="Procurar"
            single-line
          />
        </v-col>

        <v-col cols="12">
          <v-data-table
            v-model="validacoesSelecionadas"
            :headers="headers"
            :hide-default-footer="loading"
            :hide-default-header="loading"
            :items="validacoes"
            :items-per-page="itemsPerPage"
            :loading="loading"
            :mobile-breakpoint="0"
            :page.sync="currentPage"
            :search.sync="search"
            class="mx-10"
            item-key="id"
            no-data-text="Nenhuma validação BDGD disponível"
            show-select
          >
            <template v-slot:[`item.status`]="{ item }">
              {{ item.status || '—' }}
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario || '—' }}
            </template>
            <template v-slot:[`item.data_execucao`]="{ item }">
              {{ formatarData(item.data_execucao) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-space-between pb-4 px-6">
        <v-btn color="error" text @click="$emit('update:activated', false)">Cancelar</v-btn>
        <v-btn color="primary" @click="confirmarSelecao">Aplicar seleção</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GestaoBdgdsErrosTarefasService from '@/services/GestaoBdgdsErrosTarefasService.js';

  export default {
    name: 'DialogSeletorValidacaoBdgd',

    props: {
      activated: {
        type: Boolean,
        required: true
      },
      erroId: {
        type: [Number, String],
        required: true
      },
      selecionados: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Status', value: 'status' },
        { text: 'Usuário', value: 'usuario' },
        { text: 'Data de execução', value: 'data_execucao' }
      ],
      validacoes: [],
      validacoesSelecionadas: [],
      loading: false
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    created() {
      this.carregarValidacoes();
    },

    methods: {
      async carregarValidacoes() {
        this.loading = true;

        try {
          const { data } = await GestaoBdgdsErrosTarefasService.listarValidacoesBdgd(this.erroId);
          this.validacoes = Array.isArray(data?.data) ? data.data : [];
          this.sincronizarSelecionados();
        } catch (error) {
          this.$toast.error('Erro ao recuperar as validações BDGD.', '', { position: 'topRight' });
        } finally {
          this.loading = false;
        }
      },

      confirmarSelecao() {
        this.$emit('selected', [...this.validacoesSelecionadas]);
        this.search = '';
      },

      formatarData(data) {
        if (!data) return '—';

        const [dataIso, horario] = data.split(' ');
        const [ano, mes, dia] = dataIso.split('-');

        return `${dia}/${mes}/${ano}${horario ? ` ${horario.slice(0, 5)}` : ''}`;
      },

      sincronizarSelecionados() {
        const idsSelecionados = new Set(this.selecionados.map((validacao) => validacao.id));
        this.validacoesSelecionadas = this.validacoes.filter((validacao) => idsSelecionados.has(validacao.id));
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      },
      selecionados: {
        deep: true,
        handler() {
          this.sincronizarSelecionados();
        }
      }
    }
  };
</script>
